import { render, staticRenderFns } from "./edit-from-coach.vue?vue&type=template&id=6fa09022&scoped=true"
import script from "./edit-from-coach.vue?vue&type=script&lang=js"
export * from "./edit-from-coach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa09022",
  null
  
)

export default component.exports